/*
 * Types.
 */

export enum CancelStepTypesEnum {
  CONFIRM_CANCEL,
  VIEW_CONFIRMATION,
}
